<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.key"
          style="width: 24%"
          placeholder="搜索标题/内容/姓名/手机号"
          clearable
          @clear="onLoad()"
          @keyup.enter="onSearch()"
        ></el-input>
        <el-select
          v-model="state.params.zt"
          placeholder="回复状态"
          clearable
          style="width: 14%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-option label="待回复" :value="0"></el-option>
          <el-option label="已回复" :value="1"></el-option>
        </el-select>
        <el-dropdown
          split-button
          @click="onSearch()"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.order,
          order: state.params.asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.pageIndex - 1) * state.params.pageSize + index + 1
          "
          align="center"
        />
        <el-table-column prop="YkId" label="游客ID" align="center" width="80" />
        <el-table-column prop="YkXm" label="提问人" width="110" />
        <el-table-column label="手机号" width="130">
          <template #default="{ row }">
            <el-link
              v-if="row.Sjhm"
              type="primary"
              :underline="false"
              :href="'tel:' + row.Sjhm"
              >{{ row.Sjhm }}</el-link
            >
            <span v-else style="color: #999">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="Bt" label="标题" min-width="140" show-overflow-tooltip />
        <el-table-column label="问询内容" min-width="220" show-overflow-tooltip>
          <template #default="{ row }">
            <el-link type="primary" :underline="false" @click="onView(row)">
              {{ row.Nr }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="状态" sortable="Zt" align="center" width="90">
          <template #default="{ row }">
            <el-tag v-if="row.Zt == 1" type="success" size="small">已回复</el-tag>
            <el-tag v-else type="warning" size="small">待回复</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="回复内容" min-width="160" show-overflow-tooltip>
          <template #default="{ row }">
            <span v-if="row.HfNr" style="color: #409eff">{{ row.HfNr }}</span>
            <span v-else style="color: #999">未回复</span>
          </template>
        </el-table-column>
        <el-table-column label="回复人" width="100">
          <template #default="{ row }">
            {{ row.HfrXm || '—' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="提问时间"
          width="160"
          :formatter="(row) => formatTime(row.Cjsj)"
        />
        <el-table-column
          prop="Hfsj"
          sortable="Hfsj"
          label="回复时间"
          width="160"
          :formatter="(row) => formatTime(row.Hfsj)"
        />
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="ChatDotRound"
              link
              @click="onOpenReply(row)"
            >
              {{ row.Zt == 1 ? "修改回复" : "回复" }}
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.pageIndex"
        @onLoad="
          (pageIndex) => {
            state.params.pageIndex = pageIndex;
            onLoad();
          }
        "
      >
      </c_page>
    </ul>

    <!-- 问询详情弹窗 -->
    <el-dialog v-model="state.viewVisible" title="问询详情" width="560px">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="提问人">
          {{ state.viewRow.YkXm }}（ID：{{ state.viewRow.YkId }}）
        </el-descriptions-item>
        <el-descriptions-item label="手机号">
          {{ state.viewRow.Sjhm || "—" }}
        </el-descriptions-item>
        <el-descriptions-item label="标题">
          {{ state.viewRow.Bt }}
        </el-descriptions-item>
        <el-descriptions-item label="问询内容">
          <div style="white-space: pre-wrap">{{ state.viewRow.Nr }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="提问时间">
          {{ formatTime(state.viewRow.Cjsj) }}
        </el-descriptions-item>
        <el-descriptions-item v-if="state.viewRow.Zt == 1" label="商家回复">
          <div style="white-space: pre-wrap">{{ state.viewRow.HfNr }}</div>
        </el-descriptions-item>
        <el-descriptions-item v-if="state.viewRow.Zt == 1" label="回复时间">
          {{ formatTime(state.viewRow.Hfsj) }}
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <el-button @click="state.viewVisible = false">关 闭</el-button>
        <el-button
          type="primary"
          @click="
            state.viewVisible = false;
            onOpenReply(state.viewRow);
          "
        >
          {{ state.viewRow.Zt == 1 ? "修改回复" : "去回复" }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 回复弹窗 -->
    <el-dialog
      v-model="state.replyVisible"
      :title="state.replyRow.Zt == 1 ? '修改回复' : '商家回复'"
      width="560px"
      :close-on-click-modal="false"
    >
      <div class="reply-question">
        <div class="reply-question-title">{{ state.replyRow.Bt }}</div>
        <div class="reply-question-content">{{ state.replyRow.Nr }}</div>
      </div>
      <el-input
        v-model="state.replyContent"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8 }"
        placeholder="请输入回复内容（1000字以内）"
        maxlength="1000"
        show-word-limit
      />
      <template #footer>
        <el-button @click="state.replyVisible = false">取消</el-button>
        <el-button type="primary" @click="onReply()" :loading="state.replying"
          >确认回复</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive } from "vue";
import {
  youkezixun_getlist,
  youkezixun_hf,
  youkezixun_delete,
} from "@/http/api";

export default {
  setup() {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      params: {
        pageSize: 20,
        pageIndex: 1,
        order: "Id",
        asc: false,
        key: "",
        zt: null,
      },
      totalCount: 0,
      replyVisible: false,
      replyContent: "",
      replyId: null,
      replyRow: {},
      replying: false,
      viewVisible: false,
      viewRow: {},
    });

    onMounted(() => {
      onLoad();
    });

    const onSearch = () => {
      state.params.pageIndex = 1;
      onLoad();
    };

    const onLoad = () => {
      delete state.tableData;
      youkezixun_getlist(state.params).then((res) => {
        if (res.status == 200) {
          const { total, list } = res.data;
          state.tableData = list;
          state.totalCount = total;
        }
      });
    };

    // 排序
    const onSortChange = (column) => {
      state.params.order = column.prop;
      state.params.asc = column.order === "ascending";
      onLoad();
    };

    // 重置
    const onReset = () => {
      state.params = {
        pageSize: 20,
        pageIndex: 1,
        order: "Id",
        asc: false,
        key: "",
        zt: null,
      };
      onLoad();
    };

    // 查看详情
    const onView = (row) => {
      state.viewRow = row;
      state.viewVisible = true;
    };

    // 打开回复弹窗
    const onOpenReply = (row) => {
      state.replyRow = row;
      state.replyId = row.Id;
      state.replyContent = row.HfNr || "";
      state.replyVisible = true;
    };

    // 提交回复
    const onReply = () => {
      const content = state.replyContent?.trim();
      if (!content) {
        proxy.$message.warning("请输入回复内容");
        return;
      }
      if (content.length > 1000) {
        proxy.$message.warning("回复内容不能超过1000个字");
        return;
      }
      state.replying = true;
      youkezixun_hf(state.replyId, content)
        .then((res) => {
          if (res.status == 200) {
            proxy.$message.success(res.data);
            state.replyVisible = false;
            onLoad();
          }
        })
        .finally(() => {
          state.replying = false;
        });
    };

    // 删除
    const onDelete = (id) => {
      proxy.$confirm_func(youkezixun_delete, id, onLoad);
    };

    // 格式化时间
    const formatTime = (time) => {
      if (!time) return "—";
      return new Date(time).toLocaleString("zh-CN");
    };

    return {
      state,
      onLoad,
      onSearch,
      onSortChange,
      onReset,
      onView,
      onOpenReply,
      onReply,
      onDelete,
      formatTime,
    };
  },
};
</script>
<style scoped>
.reply-question {
  background: #faf6ef;
  border-left: 4px solid #e4870d;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
}
.reply-question-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}
.reply-question-content {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  white-space: pre-wrap;
  max-height: 160px;
  overflow-y: auto;
}
</style>
